import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLenis } from "@/hooks/useLenis";
import { useSEO } from "@/components/site/SEO";
import { SITE } from "@/config/site";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { Pricing } from "@/sections/Pricing";
import { Reveal } from "@/components/site/Reveal";

export default function PricesPage() {
  useLenis();
  useSEO({
    title: "Cleaning Prices Dublin | GoCleaning Dublin",
    description: "End of tenancy and move-out cleaning prices in Dublin. Starting prices for studios, apartments and houses plus optional extras. Send photos for an exact quote.",
    canonical: `${SITE.url}/prices`,
  });

  return (
    <div className="App bg-white">
      <Header />
      <main className="pt-24">
        <div className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-display text-5xl font-black tracking-tighter text-slate-900 sm:text-6xl">Cleaning Prices Dublin</h1>
            <p className="mt-4 max-w-2xl text-lg text-slate-600">Clear starting prices for end-of-tenancy and move-out cleaning across Dublin and Kildare. The final quote depends on the size and condition of the property.</p>
          </Reveal>
        </div>
        <Pricing />
        <section className="bg-white pb-20">
          <div className="mx-auto flex max-w-7xl flex-wrap gap-3 px-4 sm:px-6 lg:px-8">
            <Link to="/services" className="inline-flex items-center gap-2 rounded-full border-2 border-slate-200 px-6 py-3 font-bold text-slate-800 hover:border-emerald-600 hover:text-emerald-700">
              View All Services <ArrowRight size={16} />
            </Link>
            <Link to="/end-of-tenancy-cleaning-dublin" className="inline-flex items-center gap-2 rounded-full bg-emerald-700 px-6 py-3 font-bold text-white hover:bg-emerald-800">
              End of Tenancy Cleaning <ArrowRight size={16} />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
